/**
 * Load application configuration from the backend API
 * @returns {Promise<Object|null>} Configuration object or null if failed
 */
export const loadAppConfig = async () => {
  try {
    // Use relative URL to call the backend API
    const response = await fetch('/api/config');
    if (response.ok) {
      const config = await response.json();
      console.log('Loaded config from API:', config);
      return config;
    }
    console.warn('Failed to load config from API, status:', response.status);
    return null;
  } catch (error) {
    console.error('Error loading config:', error);
    return null;
  }
};

/**
 * Save application configuration to the backend API
 * @param {Object} config - Configuration object to save
 * @returns {Promise<boolean>} True if successful, false otherwise
 */
export const saveAppConfig = async (config) => {
  try {
    // Use relative URL to call the backend API
    const response = await fetch('/api/config', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(config),
    });
    
    if (response.ok) {
      console.log('Config saved successfully');
      return true;
    }
    console.error('Failed to save config, status:', response.status);
    return false;
  } catch (error) {
    console.error('Error saving config:', error);
    return false;
  }
};
